import type { ComponentConfig } from "@puckeditor/core"

export type FooterLink = { label: string; href: string }

export type FooterProps = {
  /** "simple" | "columns" */
  layout: "simple" | "columns"
  text: string
  columns: { title: string; links: FooterLink[] }[]
}

export const Footer: ComponentConfig<FooterProps> = {
  fields: {
    layout: {
      type: "radio",
      options: [
        { value: "simple", label: "Simple" },
        { value: "columns", label: "Columns" },
      ],
    },
    text: { type: "text", label: "Copyright line", contentEditable: true },
    columns: {
      type: "array",
      arrayFields: {
        title: { type: "text", label: "Column title", contentEditable: true },
        links: {
          type: "array",
          arrayFields: {
            label: { type: "text", label: "Label", contentEditable: true },
            href: { type: "text", label: "Link", contentEditable: true },
          },
          defaultItemProps: { label: "Link", href: "#" },
          getItemSummary: (l) => l?.label || "Link",
        },
      },
      defaultItemProps: { title: "Column", links: [] },
      getItemSummary: (item) => item?.title || "Column",
    },
  },

  defaultProps: {
    layout: "columns",
    text: "© 2025 Your Company. All rights reserved.",
    columns: [],
  },

  render: ({ layout, text, columns, puck }) => (
    <footer style={{ background: "#111827", color: "#9ca3af", paddingTop: 64, paddingBottom: 32 }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px" }}>
        {layout === "columns" && columns.length > 0 && (
          <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(columns.length, 4)}, 1fr)`, gap: 32, marginBottom: 48 }}>
            {columns.map((col, i) => (
              <div key={i}>
                <h4 style={{ color: "#fff", fontSize: 14, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 16 }}>{col.title}</h4>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {(col.links || []).map((l, j) => (
                    <li key={j} style={{ marginBottom: 8, fontSize: 14 }}>
                      <a
                        href={l.href}
                        style={{ color: "inherit", textDecoration: "none" }}
                        // RSC render passes no event handlers: functions cannot
                        // cross the client boundary. Editor links stay inert.
                        onClick={puck?.isEditing ? (e) => e.preventDefault() : undefined}
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
        <div style={{ borderTop: "1px solid #1f2937", paddingTop: 24, fontSize: 13, textAlign: "center" }}>{text}</div>
      </div>
    </footer>
  ),
}
